import { useTranslations } from 'next-intl';
import Modal from './Modal';
import { useSearchParams } from 'next/navigation';
import useParamsEditor from '../utils/useParamsEditor';

export default function SignatureResult() {
  const t = useTranslations('SignatureResult');
  const g = useTranslations('general');
  const modal = useSearchParams().get('signature');
  const editParam = useParamsEditor();

  let content = <></>;
  let status = <></>;
  switch (modal) {
    case 'completed':
      status = <h2>{t('header-completed')}</h2>;
      content = (
        <>
          <br></br>
        </>
      );
      break;
    case 'rejected':
      status = <h2>{t('header-rejected')}</h2>;
      content = <>{t('rejectedContent')}</>;
      break;
    case 'postponed':
      status = <h2>{t('header-postponed')}</h2>;
      content = <>{t('postponedContent')}</>;
      break;
    default:
      content = <></>;
      status = <></>;
  }

  if (!modal) {
    return null;
  }

  return (
    <Modal customClose={() => editParam('signature')}>
      <div className='flex flex-col gap-3'>
        <h2 className='text-2xl font-bold uppercase text-brand'>{status}</h2>
        {content}
        <button
          onClick={() => editParam('signature')}
          className='rounded-sm border border-brand bg-brand px-4 py-2 text-center font-semibold uppercase text-dark transition-all hover:bg-transparent hover:text-white'
        >
          {g('ok')}
        </button>
      </div>
    </Modal>
  );
}
